import React, { Component, Fragment } from 'react';
import './InventarioEquipos.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEquipos } from '../../../redux/actions/dataactions';
import { Link } from 'react-router-dom';
import { FaArrowCircleLeft, FaFilePdf } from "react-icons/fa";
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';


export class InventarioEquipos extends Component {
    componentDidMount(){
       this.props.getEquipos(this.props.user.credentials.idprestador);
      
      }

     

   render() {

    const { equipos, loadingdata } = this.props.data;

    const columns = [
       {
        field: 'acciones',
        headerName: 'Acciones',
        width: 80,
        sortable: false,
        filterable: false,
        renderCell: (params) => (
          <Tooltip title="Ver Perfil">
            <IconButton
              size="medium"
              component={Link}
              to={`/dashboard/inventarioequiposasistencial/hojadevidaequipo/${params.row.equipoid}/${this.props.user.credentials.idprestador}`}
            >
              <AssignmentIcon sx={{ color: '#03178C' }} fontSize="inherit" />
            </IconButton>
          </Tooltip>
        ),
      },
      {
        field: 'imagenurl',
        headerName: 'Avatar',
        width: 80,
        renderCell: (params) => (
          <img src={params.value} style={{ width: 50, borderRadius: '50%' }} alt="avatar" />
        ),
        sortable: false,
        filterable: false,
      },
      { field: 'idinventario', headerName: 'No. Inventario', width: 130 },
      { field: 'nombre', headerName: 'Nombre', width: 150 },
      { field: 'marca', headerName: 'Marca', width: 120 },
      { field: 'modelo', headerName: 'Modelo', width: 120 },
      { field: 'serie', headerName: 'Serie', width: 150 },
      { field: 'ubicacion', headerName: 'Ubicación', width: 150 },
      { field: 'servicio', headerName: 'Servicio', width: 130 },
      { field: 'estado', headerName: 'Estado', width: 100 },
      { field: 'registroinvima', headerName: 'R. Invima', width: 120 },
      { field: 'riesgo', headerName: 'Riesgo', width: 100 },
     
    ];
    
   let mapeoequipos = !loadingdata ? (
      <div>
        <div className='div-container-links-inventario'>
          <Fragment>
            <Link className='div-card-link' to={`/dashboard/inventarioequiposasistencial/${this.props.user.credentials.idprestador}`} state={equipos}>
              <div className="dashing-cardcontent">
                <div className="dashing-cardtext">
                  <p className="dashing-text-card">Exportar Inventario</p>
                </div>
                <div className="dashing-cardicon-green">
                  <FaFilePdf color="#FFFFFF" className="dashing-icon" />
                </div>
              </div>
            </Link>
          </Fragment>
        </div>
        <DataGrid
          rows={equipos}
          columns={columns}
          getRowId={(row) => row.equipoid}
          components={{
            Toolbar: () => (
              <Box p={1}>
                <GridToolbarQuickFilter placeholder="Buscar..." />
              </Box>
            ),
          }}
          sx={{
            height: 500,
            width: '100%',
            mt: 2,
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: 'primary.main',
              color: 'white',
            },
          }}
        />
      </div>
    ) : (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress size={50} color="primary" />
      </Box>
    );


     return (
        <div className='inventario-container'>

        <div className="titulomarket_section">
        <div className="titulo_market">
        <h1 className="text-clientes">Inventario Equipos Biomedicos</h1>
        <hr className="clientes_separator"></hr>  

        </div>

        <div className="divmarket_boton">
        <Link to={`/dashboard/equiposasistencial`}>
          <Tooltip title="Volver">
            <IconButton size="medium">
              <FaArrowCircleLeft color="#03178C" size={25} />
            </IconButton>
          </Tooltip>
        </Link>
        </div>
        </div>
        {mapeoequipos}
    </div>
    )
  }
}

InventarioEquipos.propTypes={
    getEquipos:PropTypes.func.isRequired,
    data:PropTypes.object.isRequired,
    user:PropTypes.object.isRequired,
}
const mapStateToProps=state=>({
    data:state.data,
    user:state.user
})

export default connect(mapStateToProps,{getEquipos}) (InventarioEquipos);